import { render, staticRenderFns } from "./BucketAdmin.vue?vue&type=template&id=0a90def2&scoped=true&"
import script from "./BucketAdmin.vue?vue&type=script&lang=js&"
export * from "./BucketAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a90def2",
  null
  
)

export default component.exports